module.exports = __webpack_public_path__ + "img/logo-nobackground.ebebd95b.png";